var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.1665L12.5869 10.8499C12.4813 12.5574 12.4285 13.4112 12.0005 14.0251C11.7889 14.3286 11.5165 14.5847 11.2005 14.7772C10.5614 15.1665 9.706 15.1665 7.99513 15.1665C6.28208 15.1665 5.42553 15.1665 4.78603 14.7764C4.46987 14.5836 4.19733 14.327 3.98579 14.023C3.55792 13.4082 3.5063 12.5532 3.40307 10.8433L3 4.1665",
    stroke: "#585B5F",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.32324H10",
    stroke: "#585B5F",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.936H9",
    stroke: "#585B5F",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.16683H14M10.7037 4.16683L10.2486 3.22798C9.94627 2.60434 9.79507 2.29251 9.53433 2.09804C9.47653 2.0549 9.41527 2.01652 9.3512 1.9833C9.06247 1.8335 8.71593 1.8335 8.02287 1.8335C7.3124 1.8335 6.9572 1.8335 6.66366 1.98958C6.59861 2.02417 6.53653 2.0641 6.47807 2.10894C6.2143 2.3113 6.06696 2.63453 5.77228 3.281L5.36849 4.16683",
    stroke: "#585B5F",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1c59b771fbda5920e6dea649ff5c4117.svg";
export { ForwardRef as ReactComponent };